import React, { useContext, useMemo } from 'react';
import { CustomField, CustomFieldUtil } from '../../../../../types/custom_field';
import DateTimeFilterDropdownContent from '../../DateTimeFilter/DropdownContent/DateTimeFilterDropdownContent';
import { BaseFilterProps } from '../../common/BaseFilter';
import { CalendarIcon } from '../../../../icons/Calendar/CalendarIcon';
import { UserContext } from '../../../../../context/UserContext';
import FilterDropdown from '../../common/FilterDropdown';

interface CustomFieldFilterDateContentProps {
  customField: CustomField;
  props: BaseFilterProps;
}

export const CustomFieldFilterDateContent = ({ customField, props }: CustomFieldFilterDateContentProps) => {
  const { locale } = useContext(UserContext);

  const value = useMemo(() => {
    const value = props.filterProps.customFieldValues?.get(customField.id);
    if (!value || !value.size || value.size < 2) return undefined;

    const dates = value.values();
    const start = dates.next().value;
    const end = dates.next().value;

    if (!start || !end) return undefined;
    return { start: new Date(start), end: new Date(end) };
  }, [props]);

  const text = (props: BaseFilterProps) => {
    if (!props || !value) return customField.name;
    return `${new Date(value.start).toLocaleDateString(locale)} - ${new Date(value.end).toLocaleDateString(locale)}`;
  };

  const toInnerContent = (props: BaseFilterProps) => {
    return <div className='py-1 text-sm text-gray-500'>{text(props)}</div>;
  };

  const handleChange = (props: BaseFilterProps, start?: Date, end?: Date) => {
    if (!props.filterProps.customFieldValues) props.filterProps.customFieldValues = new Map();

    if (!start || !end) {
      props.filterProps.customFieldValues.delete(customField.id);
    } else {
      props.filterProps.customFieldValues.set(customField.id, new Set([start.toString(), end.toString()]));
    }
    props.setFilterProps({ ...props.filterProps });
  };

  return (
    <>
      <p className='mb-1 text-sm text-gray-900'>{`${customField.name} (${CustomFieldUtil.customFieldEntityTypeToString(
        customField.entityType,
      )})`}</p>
      <FilterDropdown
        width={'fit-content'}
        icon={<CalendarIcon />}
        innerContent={toInnerContent(props)}
        dropdownContent={
          <DateTimeFilterDropdownContent
            key={'dateTimeFilterContent'}
            timeFrame={value}
            color={'black'}
            onChange={(start, end) => handleChange(props, start, end)}
          />
        }
      />
    </>
  );
};
